import { useEffect, useState } from 'react'
import { getConversation } from '../../api/api'
import { ConversationModalContent } from './ConversationModal'

const NOT_FOUND_MESSAGE = 'This conversation could not be found. It may have been deleted.'

export const useConversationById = (conversationId: string | null): ConversationModalContent | null => {
  const [content, setContent] = useState<ConversationModalContent | null>(null)

  useEffect(() => {
    if (conversationId === null) {
      setContent(null)
      return
    }

    const controller = new AbortController()
    setContent({ kind: 'loading' })
    getConversation(conversationId, controller.signal)
      .then((conversation) => {
        if (controller.signal.aborted) return
        setContent(conversation ? { kind: 'loaded', conversation } : { kind: 'unavailable', message: NOT_FOUND_MESSAGE })
      })
      .catch((err: unknown) => {
        if (controller.signal.aborted) return
        setContent({ kind: 'unavailable', message: err instanceof Error ? err.message : 'Failed to load conversation' })
      })
    return () => controller.abort()
  }, [conversationId])

  return content
}
